import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import { toMask } from '../../services/currency';

type ProductModel = {
  id: number;
  name: string;
  price: number;
};

export default function ProductsIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([] as ProductModel[]);

  const {
    user: { organization },
  } = useAuth();

  async function getProducts() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/products`
      );
      setProducts(response.data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getProducts();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Produtos' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Nome</th>
            <th scope='col'>Preço</th>
          </tr>
        </thead>
        <tbody>
          {products.map((i) => {
            return (
              <tr key={i.id}>
                <th scope='row'>{i.id}</th>
                <td>
                  <Link to={`${i.id}/edit`}>{i.name}</Link>
                </td>
                <td>{toMask(i.price)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
